module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+PHBhdGggZD0iTTc3LjUgNDEuNWgtMjJ2LTM0bC0zMyA1MWgyMnYzNHoiLz48L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_electro.svg
// module id = XPev
// module chunks = 1